// SettingsAccountDisplayPane.jsx

import React from 'react';

// Components
import SettingsModalPaneHeader from './SettingsModalPaneHeader';
import SettingsModalPaneContents from './SettingsModalPaneContents';
import Switch from 'components/switch/Switch';

/**
 * SettingsAccountDisplayPane
 *
 * Renders member-level display preferences for the active base.
 *
 * @param {object} theme - Active theme tokens for dynamic styling.
 * @param {boolean} isDarkMode - Effective dark mode state for current base.
 * @param {function} onThemeModeChange - Callback invoked when account dark mode toggle changes.
 * @param {boolean} isUsingBaseDefault - Whether user has not set a personal override yet.
 *
 * @returns {ReactNode} The rendered account display settings pane.
 */
const SettingsAccountDisplayPane = React.memo(({
    theme,
    isDarkMode,
    onThemeModeChange,
    isUsingBaseDefault,
}) => {

    // ----- RENDER ----- //

    return (
        <>
            <SettingsModalPaneHeader
              title="Display"
              subtitle="Personal appearance preferences"
            />

            <SettingsModalPaneContents>
                <div className="settings-modal-theme-card">
                    <div className="settings-modal-theme-meta">
                        <div
                          className="settings-modal-setting-label"
                          style={{
                            color: theme.foreground,
                          }}
                        >
                            Dark Mode
                        </div>
                        <div
                          className="settings-modal-setting-description"
                          style={{
                            color: theme.foregroundMuted,
                          }}
                        >
                            {isUsingBaseDefault
                                ? 'Currently using space default. Toggle to set your personal preference for this base.'
                                : 'Your personal preference for this base.'}
                        </div>
                    </div>

                    <Switch
                      checked={isDarkMode}
                      onChange={onThemeModeChange}
                    />
                </div>
            </SettingsModalPaneContents>
        </>
    );
});

// Dev Tools
SettingsAccountDisplayPane.displayName = 'SettingsAccountDisplayPane';

export default SettingsAccountDisplayPane;
